import React from 'react';
import { cn } from '@/lib/utils';

interface CalculatorTabProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: (id: string) => void;
}

export const CalculatorTab: React.FC<CalculatorTabProps> = ({
  id,
  label,
  isActive,
  onClick,
}) => {
  return (
    <button
      onClick={() => onClick(id)}
      className={cn(
        "flex-1 px-4 py-3 text-sm font-medium text-center transition-all duration-300 relative",
        "border-b-2 whitespace-nowrap",
        isActive
          ? "text-primary border-primary bg-primary/5"
          : "text-muted-foreground border-transparent hover:text-foreground hover:border-primary/30"
      )}
    >
      {label}
    </button>
  );
};